import React from "react";

const RULES = [
    "AI may summarise, flag or route for review.",
    "AI may not diagnose.",
    "AI may not prescribe.",
    "AI may not recommend treatment.",
    "AI may not approve clinical action.",
    "AI may not override patient consent.",
    "AI may not access raw patient data outside the approved evidence boundary.",
    "AI may not send raw patient records to pharma, research or community-support roles.",
];

export const ResponsibleAiBoundary = () => (
    <section className="panel" data-testid="responsible-ai-boundary">
        <div className="px-6 sm:px-8 py-5 border-b hairline">
            <p className="mono-label">Safety panel</p>
            <h2
                className="font-serif mt-1"
                style={{ fontSize: 28, letterSpacing: "-0.01em" }}
            >
                Responsible AI boundary
            </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2">
            {RULES.map((r, i) => (
                <div
                    key={i}
                    className={`px-6 sm:px-8 py-4 border-b hairline ${
                        i % 2 === 0 ? "md:border-r" : ""
                    }`}
                >
                    <div className="flex items-baseline gap-4">
                        <span className="mono-label">
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        <p style={{ fontSize: 14.5 }}>{r}</p>
                    </div>
                </div>
            ))}
        </div>
        <div className="px-6 sm:px-8 py-5 border-t hairline panel-alt">
            <p
                className="font-serif"
                style={{
                    fontSize: 17,
                    color: "var(--forest)",
                    letterSpacing: "-0.01em",
                }}
            >
                AI supports the review; authorised health roles make the decision.
            </p>
        </div>
    </section>
);

export default ResponsibleAiBoundary;
